module.exports = __webpack_public_path__ + "static/our-firm-92ff364d142c5842bb9ada850a9a17e9.jpg";